import ReferencePathService from "~/services/referencePathServices/referencePathService";
import {IReferencePathNodePayments, IReferencePathNodeSpecific} from "~/interfaces/referencePathInterfaces"
import {ReferenceNodeGenericTypeMap, ReferenceNodeType} from "~/enums/referenceNodeType";
import {GenericType} from '~/interfaces/genericTypeInterfaces'
import {ModelType} from '~/enums/modelType'

export default class FormPaymentDataPathService extends ReferencePathService {
  get imposterModelType(): ModelType {
    return this.referenceGenericModelType
  }

  constructor(private paymentDataNode: IReferencePathNodePayments) {
    super();
  }

  get label(): string {
    switch (this.reference()) {
      case ReferenceNodeType.FormPaymentsTotalCost:
        return 'Payment Total Cost';
      case ReferenceNodeType.FormPaymentsType:
        return 'Payment Type';
      case ReferenceNodeType.FormPaymentsDate:
        return 'Payment Date';
      case ReferenceNodeType.FormPaymentsLineItem:
        switch (this.paymentDataNode.reference_id) {
          case 'name':
            return 'Line Item Name';
          case 'sku':
            return 'Line Item SKU';
          case 'description':
            return 'Line Item Description';
          case 'amount':
            return 'Line Item Amount';
          case 'type':
            return 'Line Item Type';
          default:
            this.referenceIdForTypeError('FormPaymentDataPathService#label', this.paymentDataNode);
            break;
        }
        break;
      default:
        this.referenceTypeError('FormPaymentDataPathService#label', this.paymentDataNode);
        break;
    }
  }

  get nodes(): IReferencePathNodePayments[] {
    return [this.paymentDataNode];
  }

  reference(): ReferenceNodeType {
    return this.paymentDataNode.reference_type;
  }

  get referenceGenericModelType(): GenericType {
    return ReferenceNodeGenericTypeMap[this.reference()]
  }

  get referenceModelType(): ModelType {
    return this.referenceGenericModelType
  }

  canLinkTo(node: IReferencePathNodeSpecific): boolean {
    let decision = !node // nothing can be linked to it - end of the line
    this.debugCanLinkTo('FormPaymentDataPathService', this.paymentDataNode, node, decision)
    return decision
  }

  referenceIsCollection = false
}